import { render, staticRenderFns } from "./LegrandLogo.vue?vue&type=template&id=ccdd0cda&scoped=true&"
var script = {}
import style0 from "./LegrandLogo.vue?vue&type=style&index=0&id=ccdd0cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd0cda",
  null
  
)

export default component.exports